import {Pipe, PipeTransform} from '@angular/core';
import {Helper} from '../classes';
import {LanguageService} from '../language.service';

@Pipe({
	name: 'documentType',
	pure: true
})
export class DocumentTypePipe implements PipeTransform {
	constructor(private languageService: LanguageService) {
	}

	transform(value: string): string {
		const language = this.languageService.getCurrentLanguage();

		const allTypes = Helper.enumsHelper().getDocumentTypes(language)
		allTypes.extendTypes(Helper.enumsHelper().getCompanyDocumentTypes(language).getTypes())
		return allTypes.getTypeValue(value);
	}
}
